// application/use-cases/simple/CreateSimpleUseCase.ts

import type { Simple } from '@/domain/entities/simple';
import type { ISimpleRepository } from '@/domain/repositories/ISimpleRepository';

export class CreateSimpleUseCase {
  constructor(
    private readonly repository: ISimpleRepository
  ) {}

  async execute(
    table: string,
    simple: Omit<Simple, 'id'>
  ): Promise<Simple> {
    return this.repository.create(table, simple);
  }
}